import { createFileRoute, redirect } from '@tanstack/react-router'
import { ensureSession } from '@/lib/session'
import { ensureFirstWorkspaceSlug } from '@/lib/workspace'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const session = await ensureSession(context.queryClient)

    if (!session) {
      throw redirect({ to: '/login' })
    }

    const workspaceSlug = await ensureFirstWorkspaceSlug(context.queryClient)
    throw redirect({ to: '/w/$workspaceSlug', params: { workspaceSlug } })
  },
})
